// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomPatientInsuranceAssignForm from './data'

export default function DataVaxiomPatientInsuranceAssignFormFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomPatientInsuranceAssignForm">
      <DataVaxiomPatientInsuranceAssignForm {...props}>
        {children}
      </DataVaxiomPatientInsuranceAssignForm>
    </Flow>
  )
}
